import Prototypes from './Prototypes';

export default Prototypes;
